import React from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import AssetImportModal from "../Valuations/Assets/components/AssetImportModal";

/**
 * Dedicated page for importing survey Excel workbooks by asset category:
 * FURNITURE 1/2 → FURN, ICT A/B → ICT, EQUIPMENT → EQP.
 */
const AssetImports = () => {
  document.title = "Asset Imports | Valitan";

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Valuations" breadcrumbItem="Asset Imports" />
        <Row>
          <Col lg={10} xl={8}>
            <Card className="shadow-sm">
              <CardHeader className="bg-transparent border-bottom">
                <h5 className="mb-0">
                  <i className="ri-upload-2-line me-2" style={{ color: "#0147C8" }} />
                  Import survey assets from Excel
                </h5>
              </CardHeader>
              <CardBody>
                <AssetImportModal embedded lockCategory={false} initialCategoryCode="FURN" />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AssetImports;
